import { Flex } from '@applyboard/crystal-ui';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { ProgramIntakeInformation } from './components/ProgramIntakeInformation';
import { IntakeDetailsContextProvider } from './context/IntakeDetailsContext';
import { IntakeDetailsHeading } from './components/IntakeDetailsHeading';

export function IntakeDetailsPage() {
  useWindowDocumentTitle('Program Intake');

  return (
    <IntakeDetailsContextProvider>
      <Flex p={10} gap={8} direction="column">
        <IntakeDetailsHeading />
        <ProgramIntakeInformation />
      </Flex>
    </IntakeDetailsContextProvider>
  );
}
